import * as PIXI from "pixi.js";

window.PIXI = PIXI;
require("pixi-spine");

import FlashLib from "flashlib";
import './Imports'
import {TweenMax, Linear} from "gsap/TweenMax";
import BaseGame from "Engine/BaseGame";
import ServerManager from "./server/ServerManager";
import StatesManager from "Engine/base/states/StatesManager";
import GameModel from "./model/GameModel";
import GameSettings from "Base/settings/GameSettings";
import {StatesConfig} from "./states/StatesConfig"
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import ScaleManager from "Engine/ScaleManager";
import EntryPoint from "Engine/EntryPoint";
import PreloaderController from "Engine/base/preloader/BasePreloaderController";
import PreloaderView from "./preloader/PreloaderView";
import AutoPlaySettings from "Base/settings/AutoPlaySettings";
import LocalizeTextField from "Engine/base/localization/LocalizeTextField";
import Utils from "Engine/Utils";
import LocalizationManager from "Engine/base/localization/LocalizationManager";
import ErrorsManager from "Base/ErrorsManager";
import FreeBetsController from "Base/FreeBetsController";
import RelaxModel from "Base/model/RelaxModel";
import PostMessages from "./postmessages/PostMessages";

export default new class Game extends BaseGame {
    constructor() {
        EntryPoint.compiled = true;
        EntryPoint.localization = RelaxModel.usedLang;
        EntryPoint.mobile = PIXI.utils.isMobile.any;

        super();
        EntryPoint.Game = this;
        //PIXI.settings.GC_MODE = PIXI.GC_MODES.MANUAL;
    }

    initStartClasses() {
        new ServerManager();
        StatesManager.setStatesConfig(StatesConfig);
        GameModel.init();
        GameSettings.init();
        AutoPlaySettings.init();

        GlobalDispatcher.add('ui:spinClick', StatesManager.goToNextState, StatesManager);
    }

    onGameResized(event) {
        if (EntryPoint.mobile) {
            this.app.stage.x -= (this.gameSize.graphicsWidth - this.gameSize.width) / 2;
            this.app.stage.y = 0;
        }
    }

    initStartParams() {
        let gWidth = EntryPoint.mobile ? 1280 : 1920;
        let gHeight = EntryPoint.mobile ? 1050 : 1080;
        let grWidth = EntryPoint.mobile ? 1920 : 1920;
        let grHeight = EntryPoint.mobile ? 1080 : 1080;

        this.gameSize = {
            width: gWidth,
            height: gHeight,
            graphicsWidth: grWidth,
            graphicsHeight: grHeight
        };
        this.baseSize = {
            width: window.innerWidth,
            height: window.innerHeight,
            offsetY: 0,
            ratio: gWidth / gHeight
        };
        this.scaleData = {
            type: 'css',
            app: this.app,
            safeWidth: gWidth,
            safeHeight: gHeight,
            fullSize: true,
            gameSize: this.gameSize,
            alignHorizontal: 'center',
        };
    }

    createPreloader() {
        let gameFonts = ['ArialRegular', 'ArialBold'];

        this.preloaderController = new PreloaderController(gameFonts);
        this.preloaderController.on('preloaderLoadingComplete', this.onLoadingPreloaderComplete, this);
        this.preloaderController.on('gameLoadingComplete', this.onLoadingComplete, this);

        this.preloaderView = new PreloaderView(this.gameSize);
        this.app.stage.addChild(this.preloaderView);
    }

    hidePreloader() {
        TweenMax.to(this.preloaderView, 0.5, {
            alpha: 0, ease: Linear.easeNone, onComplete: () => {
                this.preloaderView.destroy({children: true});
            }
        });
    }

    onLoadingPreloaderComplete() {
        super.onLoadingPreloaderComplete();
        EntryPoint.configRelaxData = PIXI.Loader.shared.resources['relaxConfig'].data;
    }

    constructGame() {
        LocalizationManager.init();
        EntryPoint.configData = PIXI.Loader.shared.resources['gameConfig'].data;

        this.app.stop();
        this.main = FlashLib.createItemFromLibrary('Game', 'GameFlashLib');
        this.app.stage.addChildAt(this.main, 0);
        this.app.renderer.plugins.prepare.upload(this.main, () => {
            this.app.start();
            GlobalDispatcher.dispatch('game:gameStarted');
            ScaleManager.onResize();
            this.hidePreloader();
            //this.linkToTweenMax();
            this.linkToPixi();

            if (!EntryPoint.mobile) {
                let mask = new PIXI.Graphics();
                mask.beginFill(0x0, 1);
                mask.drawRect(0, -420, 1920, 1920);
                mask.endFill();
                this.app.stage.addChild(mask);
                this.main.mask = mask;
            }
        });
        //EntryPoint.PostMessages = new PostMessages();
    }
}
